import { BlockStack, Button, Card, Text } from '@shopify/polaris';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import LegacyDataPanel from './LegacyDataPanel';

export default function AdminLegacyStorePage() {
  const { sourceShopId } = useParams();
  const id = Number(sourceShopId);
  const navigate = useNavigate();
  const { token, onUnauthorized } = useOutletContext<{ token: string; onUnauthorized: () => void }>();
  return <BlockStack gap="400">
    <div><Button variant="plain" onClick={() => navigate('/pf-console/stores')}>← Back to stores</Button></div>
    <Card>{Number.isSafeInteger(id) && id > 0
      ? <LegacyDataPanel key={id} sourceShopId={id} token={token} onUnauthorized={onUnauthorized} />
      : <Text as="p" tone="critical">Invalid PFV1 source ID.</Text>}</Card>
  </BlockStack>;
}
